module.exports = __webpack_public_path__ + "img/img15.fc8f005c.svg";